import { render, staticRenderFns } from "./Userlist.vue?vue&type=template&id=037dcbe8&scoped=true&"
import script from "./Userlist.vue?vue&type=script&lang=js&"
export * from "./Userlist.vue?vue&type=script&lang=js&"
import style0 from "./Userlist.vue?vue&type=style&index=0&id=037dcbe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037dcbe8",
  null
  
)

export default component.exports